import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FiInbox } from "react-icons/fi";
import { useAuth } from "context/auth-context";
import { getRedeemRequestHistoryData } from "./MySurveys.api";
import { useQuery } from "@tanstack/react-query";
import { Survey } from "./MySurveys.interface";
import Pagination from "../../components/Pagination/Pagination";
import { dateFormatHandler, YYYY_MM_DD_HH_mm_ss } from "./../../lib/date-formatter-moment";
import { Badge, Card, EmptyState, LoadingBlock, PageHeader } from "components/ui";

export const getStatus = (status: string | number | boolean | React.ReactFragment) => {
  let btn: any = status;
  switch (status) {
    case "Pending":
      btn = (
        <Badge tone="warning" dot>
          {status}
        </Badge>
      );
      break;
    case "Reject":
      btn = (
        <Badge tone="danger" dot>
          {status}
        </Badge>
      );
      break;
    case "Approved":
      btn = (
        <Badge tone="success" dot>
          {status}
        </Badge>
      );
      break;
    case "Completed":
      btn = (
        <Badge tone="success" dot>
          {status}
        </Badge>
      );
      break;
    default:
      btn = status;
  }
  return btn;
};

export const Surveyvirtualwallet = () => {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const getSurveyvirtualwallet = useQuery(["virtual"], () => getRedeemRequestHistoryData(auth.panelistId, currentPage), {
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    getSurveyvirtualwallet.refetch();
  }, [currentPage]);

  if (getSurveyvirtualwallet.isLoading) {
    return (
      <div className="zs-page" data-testid="loading">
        <LoadingBlock label={t("page.referral.Loading")} />
      </div>
    );
  }

  return (
    <div className="zs-page">
      <PageHeader
        eyebrow="Rewards"
        title={t("survey.virtal.requestedhistory")}
        subtitle="Every redemption request you have made and where it stands."
      />
      <Card flush>
        <div className="zs-table-wrap is-flush">
          <table className="zs-table">
            <thead>
              <tr>
                <th scope="col">{t("survey.virtal.RequestedId")}</th>
                <th scope="col" className="is-num">
                  {t("survey.virtal.Points")}
                </th>
                <th scope="col">{t("survey.virtal.Status")}</th>
                <th scope="col">{t("survey.virtal.Requesteddate")}</th>
              </tr>
            </thead>
            <tbody>
              {getSurveyvirtualwallet?.data?.requestData?.length > 0 ? (
                getSurveyvirtualwallet?.data?.requestData?.map((survey: Survey, i: number) => {
                  return (
                    <tr key={i}>
                      <td className="font-mono text-[13px] is-strong">{survey.requestId}</td>
                      <td className="is-num is-strong">{survey.claimPoints}</td>
                      <td>
                        {survey.isVerify ? (
                          getStatus(survey.status)
                        ) : (
                          <Badge tone="warning">{t("survey.virtal.btn2")}</Badge>
                        )}
                        {survey.status === "Reject" && survey.rejectReason && (
                          <p className="mt-1 text-xs whitespace-normal text-danger">
                            {t("home.about.Reason")}: {survey.rejectReason}
                          </p>
                        )}
                      </td>
                      <td className="whitespace-nowrap text-ink-3">
                        {dateFormatHandler(survey.createdAt, YYYY_MM_DD_HH_mm_ss)}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="!p-0">
                    <EmptyState icon={<FiInbox />} title={t("page.mysurvey.nodata")} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="zs-table-footer justify-center sm:justify-end">
          <Pagination
            setCurrentPage={setCurrentPage}
            totalPages={getSurveyvirtualwallet?.data?.totalPages}
            currentPage={currentPage}
          />
        </div>
      </Card>
    </div>
  );
};
